import createIcon from '@/lib/create-icon'

const SlotsMachineIcon = createIcon(
  <svg
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='transparent'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 8.75V7.08333M12.0834 14.5833H7.91668M15.09 17.5H4.90999C4.02544 17.5 3.29496 16.809 3.24589 15.9258L2.59775 4.25912C2.54467 3.30378 3.30504 2.5 4.26185 2.5H15.7382C16.695 2.5 17.4554 3.30378 17.4023 4.25912L16.7541 15.9258C16.7051 16.809 15.9746 17.5 15.09 17.5ZM13.9954 6.6557L13.6282 8.41813C13.54 8.84154 13.1425 9.1271 12.7131 9.07557L11.9858 8.98829C10.6667 8.83 9.33337 8.83 8.01426 8.98829L7.28696 9.07557C6.85753 9.1271 6.46006 8.84154 6.37185 8.41813L6.00468 6.6557C5.91028 6.20259 6.20321 5.75936 6.65706 5.66859L6.73141 5.65372C8.88912 5.22218 11.1109 5.22218 13.2686 5.65372L13.343 5.66859C13.7968 5.75936 14.0898 6.20259 13.9954 6.6557Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
  </svg>,
  'SlotsMachineIcon'
)

export default SlotsMachineIcon
